import { render, staticRenderFns } from "./TocForm.vue?vue&type=template&id=d0bb5c44&"
import script from "./TocForm.vue?vue&type=script&lang=ts&"
export * from "./TocForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports